// حدود رفع الملفات: تحمي المنصة وقاعدة البيانات. الملفات الكبيرة تُرفع على قوقل درايف ويوضع الرابط.
export const MAX_FILE_BYTES = 2 * 1024 * 1024;      // أقصى حجم لكل ملف (غير الصور)
export const MAX_TOTAL_BYTES = 4 * 1024 * 1024;     // أقصى مجموع المرفقات في السجل الواحد
export const DRIVE_HINT = "الملف كبير. ارفعه على قوقل درايف وضع الرابط في الملاحظات (الحد الأقصى 2 ميجابايت).";

// ضغط الصورة في المتصفح قبل الرفع: أقصى بُعد 1280 بكسل وجودة جيدة، فيصغر حجمها كثيراً
export function compressImage(file, maxSide = 1280, quality = 0.72) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => resolve(reader.result);
      img.onload = () => {
        try {
          const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
          const canvas = document.createElement("canvas");
          canvas.width = Math.round(img.width * scale);
          canvas.height = Math.round(img.height * scale);
          const ctx = canvas.getContext("2d");
          ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/jpeg", quality));
        } catch { resolve(reader.result); }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
